import { CompanyTitledPage } from '../../TitledPage';
import { searchSelectNews, deleteNews } from "../../../http/api/NewsApi";
import { SearchForm } from './component/SearchBox';
import { SubTitle } from './component/Subtitle';
import { NewsTable } from './component/Table';
import { Paging } from './component/Pagination';

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';

const NewsListPage = () => {
  const [newsList, setNewsList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchCondition , setSearchCondition] = useState({
    page: 1,
    itemsPerPage: 10,
    keyword: "",
    updateDatePeriodStart: "",
    updateDatePeriodEnd : ""
  })
  const navigate = useNavigate();

  useEffect(() => {
    search({
      page: 1,
      itemsPerPage: 10,
      keyword: "",
      updateDatePeriodStart: "",
      updateDatePeriodEnd : ""
    });
  }, []);

  // SubTitle ---------------------------------------------------------
  const handleRegClick = (newsId) => (e) => {
    navigate('/company/news_edit', {
      state: {
        screenMode: 1,
        newsId: newsId
      }
    });
  };

  // SearchBox --------------------------------------------------------
  async function search (searchCondition) {
    try{
      const res = await searchSelectNews({
        newsListPage: searchCondition.page,
        itemsPerPage: searchCondition.itemsPerPage,
        keyword: searchCondition.keyword,
        updateDatePeriodStart: searchCondition.updateDatePeriodStart,
        updateDatePeriodEnd: searchCondition.updateDatePeriodEnd
      });
      setNewsList(res.newsListInfo.newsList);
      setTotalCount(res.newsListInfo.newsCount);
    } catch {
      setNewsList([]);
      setTotalCount(0);
    }
  };

  async function handleSearchClick (e) {
    setSearchCondition({...searchCondition, page: 1})
    search({...searchCondition, page: 1});
  }

  // Table ------------------------------------------------------------
  const handleEditClick = (newsId) => (e) =>  {
    navigate('/company/news_edit', {
      state: {
        screenMode: 2,
        newsId: newsId
      }
    });
  };

  const handleDeleteClick = (newsId) => async (e) => {
    const userConfirmed = window.confirm(`お知らせID：${newsId}を削除しますか？`);
    if (userConfirmed) {
      try {
        await deleteNews({ newsId: newsId });
        alert(`お知らせID：${newsId}を削除しました。`);
        window.location.reload();
      } catch {
        alert(`お知らせID：${newsId}を削除できませんでした。`);
      }
    }
  };

  // Paging -----------------------------------------------------------
  const changePage = (newPage) => {
    setSearchCondition({...searchCondition, page: newPage});
    search ({...searchCondition, page: newPage});
  };

  const changeItemsPerPage = (itemsPerPage) => {
    setSearchCondition({...searchCondition, itemsPerPage: itemsPerPage, page: 1})
    search ({...searchCondition, itemsPerPage: itemsPerPage, page: 1});
  };

  return (
    <CompanyTitledPage title="お知らせ">
      <SearchForm
        onClickSearchButton={handleSearchClick}
        searchCondition={searchCondition}
        setSearchCondition={setSearchCondition}
      />
      <SubTitle
        totalCount={totalCount}
        onClickRegButton={handleRegClick}
      />
      <NewsTable 
        newsList={newsList}
        onClickEditButton={handleEditClick}
        onClickDeleteButton={handleDeleteClick}
      />

      <Paging
        totalCount={totalCount} 
        page={searchCondition.page} 
        itemsPerPage={searchCondition.itemsPerPage}
        changePage={changePage} 
        changeItemsPerPage={changeItemsPerPage}
      />
    </CompanyTitledPage>
  );
};

export default NewsListPage;
